var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDC99-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-288, -895)",
    fill: "#B1B6C3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Row-12",
    transform: "translate(48, 895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Check",
    transform: "translate(243, 5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.278237088,7.6234865 C-0.092745696,7.25691658 -0.092745696,6.66256509 0.278237088,6.2959585 L1.6217091,4.9684305 C1.99269189,4.60182391 2.59423544,4.60182391 2.96521823,4.9684305 L7.12499768,9.07869246 L16.0347818,0.274927442 C16.4057646,-0.0916424805 17.0073081,-0.0916424805 17.3782909,0.274927442 L18.7217629,1.60245545 C19.0927457,1.96902537 19.0927457,2.56337686 18.7217629,2.92998345 L7.79675224,13.7250771 C7.42573235,14.0916471 6.8242259,14.0916471 6.45324312,13.7250405 L0.278237088,7.6234865 Z",
    id: "Icon"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.ec9092e0.svg";
export { ForwardRef as ReactComponent };